import React, { createElement } from 'react';

import Link, { LinkProps } from '../Link/Link';

export type LinkOrElementProps = {
  tag?: keyof React.JSX.IntrinsicElements;
} & LinkProps;

const LinkOrElement = (props: LinkOrElementProps): JSX.Element => {
  const { tag = 'div', children, ...otherProps } = props;
  const hasLink = Boolean(props.href);

  if (hasLink) {
    return <Link {...otherProps}>{children}</Link>;
  }

  return createElement(tag, otherProps, children);
};

export default LinkOrElement;
